const checkDate = (value, timezone) => {
  let dateAccToTZ = new Date().toLocaleString("en-US", { timeZone: timezone });
  let current = new Date(dateAccToTZ).setHours(0, 0, 0, 0);
  let date = new Date(value).setHours(0, 0, 0, 0);
  if (date < current) {
    return false;
  } else if (date > current) {
    return true;
  }
  if (new Date(value).getHours() - new Date(dateAccToTZ).getHours() < 1) {
    return false;
  } else if (
    new Date(value).getHours() - new Date(dateAccToTZ).getHours() >
    1
  ) {
    return true;
  } else {
    if (new Date(value).getMinutes() >= new Date(dateAccToTZ).getMinutes()) {
      return true;
    } else {
      return false;
    }
  }
};

export default checkDate;
